export const states = [
    { textField: 'Alabama', valueField: 'AL' },
    { textField: 'Alaska', valueField: 'AK' },
    { textField: 'Arizona', valueField: 'AZ' },
    { textField: 'Arkansas', valueField: 'AR' },
    { textField: 'California', valueField: 'CA' },
    { textField: 'Colorado', valueField: 'CO' },
    { textField: 'Connecticut', valueField: 'CT' },
    { textField: 'District of Columbia', valueField: 'DC' },
    { textField: 'Delaware', valueField: 'DE' },
    { textField: 'Florida', valueField: 'FL' },
    { textField: 'Georgia', valueField: 'GA' },
    { textField: 'Hawaii', valueField: 'HI' },
    { textField: 'Idaho', valueField: 'ID' },
    { textField: 'Illinois', valueField: 'IL' },
    { textField: 'Indiana', valueField: 'IN' },
    { textField: 'Iowa', valueField: 'IA' },
    { textField: 'Kansas', valueField: 'KS' },
    { textField: 'Kentucky', valueField: 'KY' },
    { textField: 'Louisiana', valueField: 'LA' },
    { textField: 'Maine', valueField: 'ME' },
    { textField: 'Maryland', valueField: 'MD' },
    { textField: 'Massachusetts', valueField: 'MA' },
    { textField: 'Michigan', valueField: 'MI' },
    { textField: 'Minnesota', valueField: 'MN' },
    { textField: 'Mississippi', valueField: 'MS' },
    { textField: 'Missouri', valueField: 'MO' },
    { textField: 'Montana', valueField: 'MT' },
    { textField: 'Nebraska', valueField: 'NE' },
    { textField: 'Nevada', valueField: 'NV' },
    { textField: 'New Hampshire', valueField: 'NH' },
    { textField: 'New Jersey', valueField: 'NJ' },
    { textField: 'New Mexico', valueField: 'NM' },
    { textField: 'New York', valueField: 'NY' },
    { textField: 'North Carolina', valueField: 'NC' },
    { textField: 'North Dakota', valueField: 'ND' },
    { textField: 'Ohio', valueField: 'OH' },
    { textField: 'Oklahoma', valueField: 'OK' },
    { textField: 'Oregon', valueField: 'OR' },
    { textField: 'Pennsylvania', valueField: 'PA' },
    { textField: 'Puerto Rico', valueField: 'PR' },
    { textField: 'Rhode Island', valueField: 'RI' },
    { textField: 'South Carolina', valueField: 'SC' },
    { textField: 'South Dakota', valueField: 'SD' },
    { textField: 'Tennessee', valueField: 'TN' },
    { textField: 'Texas', valueField: 'TX' },
    { textField: 'Utah', valueField: 'UT' },
    { textField: 'Vermont', valueField: 'VT' },
    { textField: 'Virginia', valueField: 'VA' },
    { textField: 'Washington', valueField: 'WA' },
    { textField: 'West Virginia', valueField: 'WV' },
    { textField: 'Wisconsin', valueField: 'WI' },
    { textField: 'Wyoming', valueField: 'WY' },
];
